<template>
    <div v-if="data.length > 0" class="flex justify-end items-center py-2 px-3 gap-4">
        <div class="text-sm leading-tight tracking-normal flex justify-center items-center text-gray-500">
            <span>{{ pageStartNum }}~</span>
            <span>{{ pageEndNum }}</span>
            <span>/{{ total }}</span>
        </div>
        <div class="flex gap-8">
            <button @click="goPrevious" :disabled="!hasPrevious" class="transform rotate-180">
                <img :src="iconPrevious" class="w-[0.47125rem] h-[0.875rem]">
            </button>
            <button @click="goNext" :disabled="!hasNext">
                <img :src="iconNext" class="w-[0.47125rem] h-[0.875rem]">
            </button>
        </div>
    </div>
</template>

<script>
import { computed } from "vue";
import vectorIcnTrue from '@/assets/vector_true.svg';
import vectorIcnFalse from '@/assets/vector_false.svg';

export default {
    name: 'BasePaginator',
    props: {
        data: {
            type: Object,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        pageStartNum: {
            type: Number,
            required: true
        },
        pageEndNum: {
            type: Number,
            required: true
        },
        hasPrevious: {
            type: Boolean,
            required: true
        },
        hasNext: {
            type: Boolean,
            required: true
        },
    },
    setup(props) {
        let iconPrevious = computed(() => props.hasPrevious ? vectorIcnTrue : vectorIcnFalse);
        let iconNext = computed(() => props.hasNext ? vectorIcnTrue : vectorIcnFalse);

        return {
            iconPrevious,
            iconNext,
        }
    },
    methods: {
        goNext() {
            this.$emit('page-changed', this.page + 1)
        },
        goPrevious() {
            this.$emit('page-changed', this.page - 1)
        },
    }
}
</script>
